const Data = {
    projects: {
        0: {
            title: "Flappy Bird Clone",
            desc: "Flappy bird clone in C++ using SFML as coursework assignment",
            detail: <ul class="list-disc ml-4 text-gray-600">
                        <li>Recreated the popular android game Flappy Bird in C++ for desktop</li>
                        <li>My first graphical application project created using SFML library</li>
                    </ul>,
            link: "https://github.com/annasabdurrahman354/FlappyBird-Clone",
            thumb: "https://github.com/annasabdurrahman354/FlappyBird-Clone/raw/main/Gameplay.PNG",
            images : [
                "https://github.com/annasabdurrahman354/FlappyBird-Clone/raw/main/1.PNG",
                "https://github.com/annasabdurrahman354/FlappyBird-Clone/raw/main/Gameplay.PNG",
                "https://github.com/annasabdurrahman354/FlappyBird-Clone/raw/main/2.PNG"
            ],
            date: "2019",
        },
        1: {
            title: "Atom.ez",
            desc: "Application for learning chemical elements and interacting with them to create compounds",
            detail: <ul class="list-disc ml-4 text-gray-600">
                        <li>Developed an native Android chemistry application in Java</li>
                        <li>Finalist in Lomba Inovasi Digital Mahasiswa by Kemendikbud RI</li>
                        <li>Enabled students to understand and memorize elements also interact with them to make some possible compound</li>
                    </ul>,
            link: "https://github.com/annasabdurrahman354/Atom.ez",
            thumb: "https://github.com/annasabdurrahman354/Atom.ez/raw/main/Screenshot/1.png",
            images : [
                "https://github.com/annasabdurrahman354/Atom.ez/raw/main/Screenshot/1.png",
                "https://github.com/annasabdurrahman354/Atom.ez/raw/main/Screenshot/2.png",
                "https://github.com/annasabdurrahman354/Atom.ez/raw/main/Screenshot/3.png",
                "https://github.com/annasabdurrahman354/Atom.ez/raw/main/Screenshot/4.png",
                "https://github.com/annasabdurrahman354/Atom.ez/raw/main/Screenshot/5.png",
                "https://github.com/annasabdurrahman354/Atom.ez/raw/main/Screenshot/6.png",
                "https://github.com/annasabdurrahman354/Atom.ez/raw/main/Screenshot/7.png",
                "https://github.com/annasabdurrahman354/Atom.ez/raw/main/Screenshot/8.png",
                "https://github.com/annasabdurrahman354/Atom.ez/raw/main/Screenshot/9.png",
                "https://github.com/annasabdurrahman354/Atom.ez/raw/main/Screenshot/10.png",
                "https://github.com/annasabdurrahman354/Atom.ez/raw/main/Screenshot/11.png",
                "https://github.com/annasabdurrahman354/Atom.ez/raw/main/Screenshot/12.png",
                "https://github.com/annasabdurrahman354/Atom.ez/raw/main/Screenshot/13.png",
            ],
            date: "2020",
        },
        2: {
            title: "Public Transportation Database System",
            desc: "Designed multi-vehicle public transportation database system",
            detail: <ul class="list-disc ml-4 text-gray-600">
                        <li>Designed a database system for various public transportation services such as flights, cruises, train and bus travel</li>
                        <li>The system aimsto provide general information about each transportation service such as departure, destination, ticket price, company, and used vehicle</li>
                        <li>Implemented the database system design in SQL Server</li>
                        <li>Developed a simple CRUD GUI application that connects to the database in Java using Java Swing</li>
                    </ul>,
            link: "https://github.com/annasabdurrahman354/Public-Transportation-Database",
            thumb: "https://github.com/annasabdurrahman354/Public-Transportation-Database/raw/main/Screenshot%20Aplikasi/2.png",
            images : [
                "https://github.com/annasabdurrahman354/Public-Transportation-Database/raw/main/Screenshot%20Aplikasi/1.png",
                "https://github.com/annasabdurrahman354/Public-Transportation-Database/raw/main/Screenshot%20Aplikasi/2.png",
                "https://github.com/annasabdurrahman354/Public-Transportation-Database/raw/main/Screenshot%20Aplikasi/3.png",
                "https://github.com/annasabdurrahman354/Public-Transportation-Database/raw/main/Screenshot%20Aplikasi/4.png",
                "https://github.com/annasabdurrahman354/Public-Transportation-Database/raw/main/Screenshot%20Aplikasi/5.png"
            ],
            date: "2020",
        },
        3: {
            title: "Turing Machine Simulator",
            desc: "A webiste that simulates and visualizes how turing machine works",
            detail: <ul class="list-disc ml-4 text-gray-600">
                        <li>Built a simple website Turing Machine simulator in JavaScript usingthe Vue.jsframework</li>
                        <li>The app simulates and visualizes how a single tape and multi-track Turing Machine works for simple mathematic operations such as addition, subtraction, multiplication, division, factorial, modulo, power-to, and binary logarithm</li>
                    </ul>,
            link: "https://github.com/annasabdurrahman354/Turing-Machine-Simulator-Website",
            thumb: "https://github.com/annasabdurrahman354/Turing-Machine-Simulator-Website/raw/master/Screenshot/1.png",
            images : [
                "https://github.com/annasabdurrahman354/Turing-Machine-Simulator-Website/raw/master/Screenshot/1.png",
                "https://github.com/annasabdurrahman354/Turing-Machine-Simulator-Website/raw/master/Screenshot/2.png",
                "https://github.com/annasabdurrahman354/Turing-Machine-Simulator-Website/raw/master/Screenshot/3.png",
                "https://github.com/annasabdurrahman354/Turing-Machine-Simulator-Website/raw/master/Screenshot/4.png",
                "https://github.com/annasabdurrahman354/Turing-Machine-Simulator-Website/raw/master/Screenshot/5.png",
            ],
            date: "2021",
        },
        4: {
            title: "Crowdfunding Website",
            desc: "A website that provides all basic feature for crowdfunding",
            detail: <ul class="list-disc ml-4 text-gray-600">
                        <li>Developed a crowdfunding website using Laravel Framework with Livewire for building dynamic interface, TailwindCSS for styling, and MySQL for database</li>
                        <li>The website provides a platform for volunteers to post a donation program, manage and give updated info about their program</li>
                        <li>The website provides some features such as an authentication system, searching a donation program, making donations, verifying donations and there are two types of dashboards, for volunteer and administrator</li>
                    </ul>,
            link: "https://github.com/annasabdurrahman354/Crowfunding-Website",
            thumb: "https://github.com/annasabdurrahman354/Crowfunding-Website/raw/main/Screenshot/1.png",
            images : [
                "https://github.com/annasabdurrahman354/Crowfunding-Website/raw/main/Screenshot/1.png",
                "https://github.com/annasabdurrahman354/Crowfunding-Website/raw/main/Screenshot/2.png",
                "https://github.com/annasabdurrahman354/Crowfunding-Website/raw/main/Screenshot/3.png",
                "https://github.com/annasabdurrahman354/Crowfunding-Website/raw/main/Screenshot/4.png",
                "https://github.com/annasabdurrahman354/Crowfunding-Website/raw/main/Screenshot/5.png",
                "https://github.com/annasabdurrahman354/Crowfunding-Website/raw/main/Screenshot/6.png",
                "https://github.com/annasabdurrahman354/Crowfunding-Website/raw/main/Screenshot/7.png",
                "https://github.com/annasabdurrahman354/Crowfunding-Website/raw/main/Screenshot/8.png",
                "https://github.com/annasabdurrahman354/Crowfunding-Website/raw/main/Screenshot/9.png",
                "https://github.com/annasabdurrahman354/Crowfunding-Website/raw/main/Screenshot/10.png",
                "https://github.com/annasabdurrahman354/Crowfunding-Website/raw/main/Screenshot/11.png",
                "https://github.com/annasabdurrahman354/Crowfunding-Website/raw/main/Screenshot/12.png",
                "https://github.com/annasabdurrahman354/Crowfunding-Website/raw/main/Screenshot/13.png",
                "https://github.com/annasabdurrahman354/Crowfunding-Website/raw/main/Screenshot/14.png",
                "https://github.com/annasabdurrahman354/Crowfunding-Website/raw/main/Screenshot/15.png",
                "https://github.com/annasabdurrahman354/Crowfunding-Website/raw/main/Screenshot/16.png",
            ],
            date: "2021",
        },
        5: {
            title: "Resume Website",
            desc: "Developed my personal website to present resume and portfolio",
            detail: <ul class="list-disc ml-4 text-gray-600">
                        <li>My personal website to present my resume and portfolio</li>
                        <li>Developed using React.js and TailwindCSS for styling</li>
                        <li>Deployed in netlify</li>
                    </ul>,
            link: "https://github.com/annasabdurrahman354/Resume-Website",
            thumb: "/screenshots/1.png",
            images : [
                "/screenshots/1.png",
                "/screenshots/2.png"
            ],
            date: "2021",
        },
        
    },
    works: {
        0: {
            title: "Cabble",
            desc: "A social media to make collaboration project easier",
            detail: <ul class="list-disc ml-4 text-gray-600">
                        <li>A social media to collaborate on an open-source project</li>
                        <li>Developed in Kotlin with the team by using Firebase</li>
                        <li>Contributing in making user interface, program's logic and making Figma prototype</li>
                        <li>Competed in National Startup Competition by TheGreaterHub SBM ITB and became one of the 40 finalists</li>
                    </ul>,
            link: false,
            thumb: "/screenshots/C1.png",
            images : [
                "/screenshots/C1.png",
                "/screenshots/C2.png",
            ],
            date: "2021",
        },
        1: {
            title: "SayFine",
            desc: "Android application to manage restaurant and connect with customer",
            detail: <ul class="list-disc ml-4 text-gray-600">
                        <li>Developed Android application in Java with Firebase which connects seller with their customer</li>
                        <li>The application has some features like authentication system, chatting with seller, menu lists, article lists, ordering, and managing orders also body mass index calculator.</li>
                        <li>The concept of the application is to provide a healthy way to eat, so every food on the menu is not junk food, has calorie and benefits information</li>
                        <li>The administrator can use a CRUD menu that can be used to manage their database in the app</li>
                    </ul>,
            link: "https://github.com/annasabdurrahman354/SayFine",
            thumb: "https://github.com/annasabdurrahman354/SayFine/raw/main/Screenshot/1.png",
            images : [
                "https://github.com/annasabdurrahman354/SayFine/raw/main/Screenshot/1.png",
                "https://github.com/annasabdurrahman354/SayFine/raw/main/Screenshot/2.png",
                "https://github.com/annasabdurrahman354/SayFine/raw/main/Screenshot/3.png",
                "https://github.com/annasabdurrahman354/SayFine/raw/main/Screenshot/4.png",
                "https://github.com/annasabdurrahman354/SayFine/raw/main/Screenshot/5.png",
                "https://github.com/annasabdurrahman354/SayFine/raw/main/Screenshot/6.png",
                "https://github.com/annasabdurrahman354/SayFine/raw/main/Screenshot/7.png",
                "https://github.com/annasabdurrahman354/SayFine/raw/main/Screenshot/8.png",
                "https://github.com/annasabdurrahman354/SayFine/raw/main/Screenshot/9.png",
                "https://github.com/annasabdurrahman354/SayFine/raw/main/Screenshot/10.png",
                "https://github.com/annasabdurrahman354/SayFine/raw/main/Screenshot/11.png",
            ],
            date: "2021",
        },  
    },
    
};

export default Data